<!--
 * @Author: Yran
 * @Date: 2021-05-12 17:58:25
 * @LastEditors: Yran
 * @LastEditTime: 2021-05-12 17:58:42
-->
<template>
  <router-view></router-view>
</template>